import React from "react";
import { DirectionType } from "./types";
import { InfoText } from "./InfoText";
import { TIMELINE_PADDING } from "@opstel/SBD/core/layoutConstants";

interface StickyInfoTextProps {
  readonly left: number;
  readonly top: number;
  readonly trainNumber: string;
  readonly type: DirectionType;
  readonly width: number;
  readonly units: string;
}

export function StickyInfoText({
  left,
  top,
  width,
  trainNumber,
  type,
  units,
}: StickyInfoTextProps): React.JSX.Element {
  return (
    <div
      className="absolute z-9"
      style={{
        left: `${TIMELINE_PADDING + left}px`,
        top: `${top}px`,
        width: `${width}px`,
      }}
    >
      <InfoText type={type} text={trainNumber} elementWidth={width} units={units} />
    </div>
  );
}
